module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.2b26bc77.ttf";